// const commonData = [];
// export default commonData;
export const IVP_AppID = "cb5edca7-9b4f-4452-8da3-5df1e018496d";
export const VLAB_AppID = "8ce43fda-c6e2-4ca1-afb1-4c44e699eb18";
export const RAAS_AppID = "ad5e73b2-4b73-4326-a163-44f0438398d9";
export const ELEARN_AppID = "35d9fb6c-d0e4-4ec0-b5b8-00302b041f9a";
// export const DigitalNagrikBase =
//   "http://10.244.2.178:8084/digitalnagriks/awareness-series";
export const DigitalNagrikBase =
  "https://digitalnaagrik.isea.app/awareness-series";
